import { useSnackbar } from '../../../context/SnackBarContext';
import WarningModal from '../../../component/WarningModal';
import MultipleSelect from '../../../component/MultipleSelect';
import { useCrm } from '../../../context/CrmContext';
import CrmSelectField from '../../../component/CrmUI/CrmProfileUI/CrmSelectField';
import { CrmUseProfile } from '../../../features/Crm/CrmProfile/CrmUseProfile';

export const CrmEditInvoiceForm = ({
  state,
  setFormData,
  formData,
  handleSaveCrmInvoice,
  setModalOpen,
  modalOpen,
  tableData,
  billingData }) => {
  const { showSuccess, showError } = useSnackbar();
  const { user } = useCrm()
  const { states } = CrmUseProfile();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };



   const validateFormData = () => {
    const requiredFields = [
      { field: 'invoiceDate', message: 'Invoice Date is required' },
      { field: 'paymentMode', message: 'Payment Mode is required' },
      { field: 'paymentStatus', message: 'Payment Status is required' },
      { field: 'customerName', message: 'Customer Name is required' },
      { field: 'billAddress', message: 'Billing Address is required' },
      { field: 'state', message: 'State is required' },

    ];

    for (let item of requiredFields) {
      if (!formData[item.field] || formData[item.field].trim() === '') {
        showError(item.message);
        return false;
      }
    }


    // Validate Sales Person Contact No
    const contactNo = formData.salesPersonContactNo?.trim();
    if (contactNo && !/^\+?\d{10,12}$/.test(contactNo)) {
      showError('Invalid Sales Person Contact No');
      return false;
    }

    return true;
  };

  const options = [{ name: "PAID" }, { name: "UNPAID" }];

  // const validateTableData = () => {
  //   for (let row of tableData) {
  //     if (!row.product) {
  //       showError('Product is required for each row');
  //       return false;
  //     }
  //     if (!row.quantity || isNaN(row.quantity) || row.quantity <= 0) {
  //       showError('Quantity Required');
  //       return false;
  //     }
  //     if (!row.price || isNaN(row.price) || row.price <= 0) {
  //       showError('Price must be a valid number');
  //       return false;
  //     }
  //   }
  //   return true;
  // };

  const validateBillingData = () => {
    if (!billingData.subTotal || parseFloat(billingData.subTotal) <= 0) {
      showError('Subtotal must be greater than 0');
      return false;
    }
    if (!billingData.total || parseFloat(billingData.total) <= 0) {
      showError('Total must be greater than 0');
      return false;
    }
    return true;
  };


  const handleSaveButton = () => {
    if (!validateFormData() || !validateBillingData()) {
      return;
    }

    setModalOpen(true)
  }

  console.log("sdfghjkllkjhgfd ===>>>", formData)

  return (
    <div>
      <div>
        <div className="flex justify-between items-center mb-4 bg-[#f4f5f7] pb-3 md:px-0 px-3">
          <h2 className="md:text-[28px] text-[20px] font-bold text-gray-800">Edit Invoice</h2>
          <button
            onClick={() => handleSaveButton()}
            className="md:px-4  px-2 md:py-2 py-1  bg-gray-800 text-white border-gray-400 border rounded hover:bg-black">
            Save
          </button>
        </div>

        <div className="md:px-5 px-2">
          <div className="shadow-[0_4px_6px_rgba(0,0,0,0.1)] p-5">
            <div className="flex md:flex-row flex-col justify-between">
              <div>
                <div>
                  <div className="mb-10">
                    <p className="font-bold text-gray-800 text-[16px]">{user?.companyName}</p>
                    <p className="text-gray-600 md:text-[16px] text-[14px] cursor-pointer">
                      {user?.address}
                    </p>
                  </div>

                  <div className="flex flex-col lg:justify-end lg:items-end lg:mt-3">
                    <div className="flex items-center space-x-6 lg:mt-3">
                      <label className="flex items-center space-x-2">
                        <input
                          type="radio"
                          name="withGst"
                          checked={formData.withGst}
                          onChange={() => setFormData({ ...formData, withGst: true })}
                          className="w-4 h-4 text-green-600 border-gray-300 focus:ring-green-500"
                        />
                        <span>With GST</span>
                      </label>

                      <label className="flex items-center space-x-2">
                        <input
                          type="radio"
                          name="withGst"
                          checked={formData.withGst == false}
                          onChange={() => setFormData({ ...formData, withGst: false })}
                          className="w-4 h-4 text-green-600 border-gray-300 focus:ring-green-500"
                        />
                        <span>Without GST</span>
                      </label>
                    </div>

                  </div>
                </div>
              </div>

              <div className='flex justify-end mt-5'>
                <div className="flex flex-col mb-4">
                  <p className="text-gray-700">Balance Due:</p>

                  <span className="text-gray-700 text-[24px] font-bold ">₹{billingData.total || "0.00"}</span>
                  <p className="text-gray-700 text-sm font-semibold mt-4">
                    # No: <span className=' text-gray-500' >00 (Auto generate)</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Invoice Details */}
          <div>
            <div className="shadow-[0_4px_6px_rgba(0,0,0,0.1)] p-5">
              <div className="grid lg:grid-cols-4 md:flex-wrap gap-4 mb-6 max-w-[1000px] mt-3 " >
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">INVOICE DATE *</label>
                  <input
                    type="date"
                    name="invoiceDate"
                    value={formData.invoiceDate}
                    onChange={handleChange}
                    className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Select Invoice Date"

                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">PAYMENT MODE *</label>
                  <input
                    type="text"
                    name="paymentMode"
                    value={formData.paymentMode}
                    onChange={handleChange}
                    className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter Payment Mode"

                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">PAYMENT STATUS *</label>
                  <MultipleSelect
                    options={options}
                    value={formData.paymentStatus}
                    onChange={handleChange}
                    label="PAYMENT STATUS"
                    name={"paymentStatus"}
                    placeholder="Select an option"
                  />
                </div>

              </div>
              <div className="grid lg:grid-cols-4 md:flex-wrap gap-4 mb-6 max-w-[1000px] mt-9">

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">PAYMENT DATE </label>
                  <input
                    type="date"
                    name="paymentDate"
                    value={formData.paymentDate}
                    onChange={handleChange}
                    className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Select Payment Date"

                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">SHIPPING / DATE</label>
                  <input
                    type="date"
                    name="shippingDate"
                    value={formData.shippingDate}
                    onChange={handleChange}
                    className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Select Shipping Date"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">SALES PERSON</label>
                  <input
                    type="text"
                    name="salesPerson"
                    value={formData.salesPerson}
                    onChange={handleChange}
                    className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter Sales Person"

                  />
                </div>


                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">SALES PERSON CONTACT NO.</label>
                  <input
                    type="text"
                    name="salesPersonContactNo"
                    value={formData.salesPersonContactNo}
                    onChange={handleChange}
                    className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter Sales Person"

                  />
                </div>

              </div>
            </div>
            <div className="shadow-[0_4px_6px_rgba(0,0,0,0.1)] p-5 mb-6">
              <div className="grid lg:grid-cols-4 grid-cols-1  gap-6">
                {/* CUSTOMER NAME */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    CUSTOMER NAME *
                  </label>
                  <input
                    type="text"
                    name="customerName"
                    value={formData.customerName}
                    onChange={handleChange}
                    className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter Customer Name"
                  />


                  <label className="block text-sm font-semibold text-gray-700 mb-2 mt-4">
                    PHONE NUMBER
                  </label>
                  <input
                    type="text"
                    name="phoneNumber"
                    value={formData.customerPhone}
                    onChange={handleChange}
                    className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter Phone Number"
                  />
                </div>

                {/* BILLING ADDRESS */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    BILLING ADDRESS *
                  </label>
                  <textarea
                    name="billAddress"
                    value={formData.billAddress}
                    onChange={handleChange}
                    className="w-full border p-2 rounded h-32 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter Billing Address"
                  />
                </div>

                {/* SHIPPING ADDRESS */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    SHIPPING ADDRESS
                  </label>
                  <textarea
                    name="shipingAddress"
                    value={formData.shipingAddress}
                    onChange={handleChange}
                    className="w-full border p-2 rounded h-32 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter Shipping Address"
                  />
                </div>

                {/* PHONE NUMBER */}
                <div>


                  <CrmSelectField label="State *" name="state" value={formData.state} onChange={handleChange} options={states} />
                  {formData.withGst && (
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2 mt-4">
                        GST NUMBER *
                      </label>
                      <input
                        type="text"
                        name="gstNumber"
                        value={formData.gst}
                        onChange={handleChange}
                        className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter GST Number"
                      />
                    </div>
                  )}

                  {/* <label className="block text-sm font-semibold text-gray-700 mb-2 mt-4">
                    SELECT STATE *
                  </label>
                  <select
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                    options={states}
                  >
                  </select> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <WarningModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        modalTitle="Are you sure you want to save this invoice?"
        onConfirm={handleSaveCrmInvoice}
        onCancel={() => setModalOpen(false)}
        confirmText="Yes, Confirm"
        cancelText="Cancel"
        isLoading={state.isLoading}
        color={false}
      />
    </div >
  );
};